import {
  Alert,
  AlertDescription,
  AlertIcon,
  AlertTitle,
  Text,
  UseDisclosureReturn,
  VStack,
} from "@chakra-ui/react";
import React from "react";
import { deleteWallet } from "../../../../store/actions/wallet";
import { ConfirmActionModal } from "../../../modals/ConfirmActionModal";

export function DeleteWalletModal({
  accountId,
  walletId,
  walletName,
  disclosure,
}: {
  accountId: string;
  walletId: string;
  walletName: string;
  disclosure: UseDisclosureReturn;
}): React.ReactElement {
  const onConfirm = async () => {
    await deleteWallet(accountId, walletId);
  };

  return (
    <ConfirmActionModal
      disclosure={disclosure}
      title="Delete data source"
      confirmButtonText="Delete data source"
      colorScheme="red"
      onConfirm={onConfirm}
    >
      <VStack align="stretch" spacing={4}>
        <Text>
          Are you sure you want to delete{" "}
          <Text as="span" fontWeight="bold">
            {walletName}
          </Text>
          ?
        </Text>

        <Alert status="warning" borderRadius="md" alignItems="flex-start">
          <AlertIcon />
          <VStack align="flex-start" spacing={2}>
            <AlertTitle>This can’t be undone.</AlertTitle>
            <AlertDescription>
              This data source and its imported transactions will be permanently
              removed.
            </AlertDescription>
          </VStack>
        </Alert>
      </VStack>
    </ConfirmActionModal>
  );
}
